import { NonIdealState } from '@blueprintjs/core'
import React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import { getRedirectReferrerPath } from '../../shared'

import './not-found.scss'

type Props = RouteComponentProps<{}>

export const NotFound = ({ location }: Props) => {
  const from = getRedirectReferrerPath(location, location.pathname)
  const message = `We are very sorry but ${from} doesn't exist!`

  return (
    <div className="not-found">
      <NonIdealState title="404 - Not Found" description={message} icon="pulse" />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/app/core/components/not-found.tsx